import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import DonutLargeIcon from '@material-ui/icons/DonutLarge'
import LooksIcon from '@material-ui/icons/Looks'

import { Card, CardHeading, CardContent } from '../layout/Card'
import { Allocations } from '../Allocations'
import { sanitizeAssetAllocations } from './helper'

/* AllocationsOverview renders a single asset allocation pie chart
 * that shows the overall asset allocations for all assets.
 *
 * @param assetAllocationsDataset: Array of assetAllocations
 */
export const AllocationsOverview = ({ assetAllocationsDataset, filter, ...rest }) => {
  const [donutView, setDonutView] = useState(true)
  const sanitizedAssetAllocations = assetAllocationsDataset.map(assetAllocations => sanitizeAssetAllocations(assetAllocations))
  return (
    <Card className='allocations hidden sm:flex' {...rest}>
      <AllocationHeading filter={filter} onClick={() => setDonutView(!donutView)} donutView={donutView} />
      <CardContent>
        <Allocations assetAllocationsDataset={sanitizedAssetAllocations} semiCircle={!donutView} />
      </CardContent>
    </Card>
  )
}

const AllocationHeading = ({ donutView, onClick, filter }) =>
  <>
    <CardHeading className='flex'>
      <div className='flex-[2] flex gap-2'>
        <h5>Asset allocation overview</h5>
        <ToggleAllocationView onClick={onClick} donutView={donutView} />
      </div>
      <div className='flex-1'>
        {filter ? filter() : null}
      </div>
    </CardHeading>
  </>

const ToggleAllocationView = ({ donutView, onClick }) =>
  donutView
    ? <LooksIcon onClick={onClick} style={{ cursor: 'pointer' }} />
    : <DonutLargeIcon onClick={onClick} style={{ cursor: 'pointer' }} />

AllocationsOverview.propTypes = {
  assetAllocations: PropTypes.object,
  filter: PropTypes.func,
}
